import { useCallback, useMemo } from 'react';
import { usePromise } from 'common/hooks/usePromise';
import { ApiCallResultStatus } from 'store/apiCallResultStatus';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useNotifications } from 'store/layout/hooks/useNotifications';

import { getNotificationSettingResubscribeStatus } from './notificationSelectors';
import { unauthUpdateSelfEmailNotificationSettingAsync } from './notificationsSlice';

/**
 * Helper hook for managing notification settings from the unauthenticated unsubscribe page
 */
export const useUnauthNotificationSettings = () => {
  const dispatch = useAppDispatch();
  const scopePromise = usePromise();
  const { toastGenericError } = useNotifications();

  const notificationSettingResubscribeStatus = useAppSelector(({ notifications }) =>
    getNotificationSettingResubscribeStatus(notifications)
  );

  const isResubscribed = useMemo(
    () =>
      notificationSettingResubscribeStatus?.status === ApiCallResultStatus.SUCCESS &&
      notificationSettingResubscribeStatus?.response?.isEnabled,
    [notificationSettingResubscribeStatus]
  );

  const resubscribe = useCallback(() => {
    return scopePromise(dispatch(unauthUpdateSelfEmailNotificationSettingAsync(true)).unwrap()).catch((error) => {
      toastGenericError(error, 'unauthUpdateSelfEmailNotificationSetting');
    });
  }, [dispatch, toastGenericError, scopePromise]);

  return {
    resubscribe,
    isResubscribed,
  };
};
